// 获取到时间戳，改成时间格式
export default function newFormatDate (now) {
    const year = now.getFullYear() // 取得4位数的年份
    const month = ('0' + (now.getMonth() + 1)).slice(-2) // 取得日期中的月份，其中0表示1月，11表示12月
    const date = ('0' + now.getDate()).slice(-2) // 返回日期月份中的天数（1到31）
    return (
      year + '/' + month + '/' + date
    )
  }